module.exports = __webpack_public_path__ + "img/teeth-34.24ba5a84.png";